
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {addressGroups} from './message-viewer';
import { isSentFolder as checkIsSentFolder } from '../../services/folder';

const HeaderTo = (props) => {
  const { recipients, isSentFolder } = props;
  const { t } = useTranslation();

  const to = recipients?.filter(r => r.type === 'To') || [];
  const cc = recipients?.filter(r => r.type === 'Cc') || [];
  const bcc = recipients?.filter(r => r.type === 'Bcc') || [];

  const formatList = list => list
    .map(entry => addressGroups(entry.address))
    .map(g => g.email)
    .filter(Boolean)
    .join(', ');

  const toStr = formatList(to);
  const ccStr = formatList(cc);
  const bccStr = formatList(bcc);

  const sections = [
    toStr ? (<span key="to" title={toStr}><span className="font-weight-bold">{t('message-header.to')}:</span> {toStr}</span>) : null,
    ccStr ? (<span key="cc" title={ccStr}><span className="font-weight-bold">{t('message-header.cc')}:</span> {ccStr}</span>) : null,
    (isSentFolder && bccStr) ? (
      <span key="bcc" title={bccStr}><span className="font-weight-bold">{t('message-header.bcc')}:</span> {bccStr}</span>
    ) : null
  ].filter(Boolean);

  if (sections.length === 0) {
    return null;
  }

  const inline = sections.reduce((acc, section, index) => {
    if (index === 0) {
      return [section];
    }
    return acc.concat([' · ', section]);
  }, []);

  return (
    <div className="header-name">
      {inline}
    </div>
  );
}


HeaderTo.propTypes = {
  className: PropTypes.string,
  recipients: PropTypes.array.isRequired,
  isSentFolder: PropTypes.bool
};


const mapStateToProps = state => {
  const selectedFolderId = state && state.application && state.application.selectedFolderId;
  const explodedItems = state && state.folders && state.folders.explodedItems;
  const selectedFolder = selectedFolderId && explodedItems ? explodedItems[selectedFolderId] : null;
  return { isSentFolder: checkIsSentFolder(selectedFolder) };
};


export default connect(mapStateToProps)(HeaderTo);
